<template>
  <v-container fluid v-if="model">
    <v-alert
      type="error"
      dismissible
      transition="scale-transition"
      v-for="(msg, idx) in message"
      :key="'error_'+idx"
      >{{ msg }}</v-alert
    >
    <v-row v-if="this.model">
      <v-col cols="8">
        <v-row>
          <v-col>
            <v-card :disabled="loading">
              <v-toolbar tabs flat>
                <v-icon left color="accent">mdi-clipboard-text</v-icon>
                <v-toolbar-title v-if="this.model.statusId != 'new'"
                  >Order</v-toolbar-title
                >
                <v-toolbar-title v-else>Quote</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn
                  outlined
                  v-if="this.model.prescriptionId"
                  :to="'/prescription/view/' + this.model.prescriptionId"
                  class="mr-2"
                >
                  <v-icon left>mdi-arrow-left</v-icon>Prescription
                </v-btn>

                <v-menu bottom left>
                  <template v-slot:activator="{ on }">
                    <v-btn outlined v-on="on">
                      <v-icon left>mdi-printer</v-icon>Print
                    </v-btn>
                  </template>

                  <v-list>
                    <v-list-item
                      v-if="$can('access', 'Order')"
                      :to="'/orders/print/' + this.model.id + '/regrouped'"
                    >
                      <v-list-item-title
                        >{{
                          this.model.invoice ? "Order confirmation" : "Quote"
                        }}
                        (grouped by Set)</v-list-item-title
                      >
                    </v-list-item>
                    <v-list-item
                      :to="'/orders/print/' + this.model.id + '/assembled'"
                    >
                      <v-list-item-title
                        >{{
                          this.model.invoice ? "Order confirmation" : "Quote"
                        }}
                        (assembled)</v-list-item-title
                      >
                    </v-list-item>
                  </v-list>
                </v-menu>
                <template v-slot:extension>
                  <v-tabs v-model="tabs" color="accent" slider-color="accent">
                    <v-tab key="1" ripple>Order Details</v-tab>
                    <v-tab key="2" ripple>Customer Details <v-icon v-if="!canBeValidate" class="ml-2" color="red" small>mdi-alert</v-icon></v-tab>
                    <v-tab key="3" ripple v-if="$can('discount', 'Order')">Discount</v-tab>
                    <v-tab key="4" ripple>History</v-tab>
                    <v-tab key="5" ripple>Comments</v-tab>
                  </v-tabs>
                </template>
              </v-toolbar>
              <v-tabs-items v-model="tabs" class="">
                <v-tab-item key="1">
                  <order-detail
                    :order="this.model"
                    :editable="!this.model.prescriptionId && this.model.statusId == 'new'"
                    @updated="getOrder(model.id)"
                  ></order-detail>
                </v-tab-item>
                <v-tab-item key="2">
                  <customer-detail
                    :order="this.model"
                    @updated="getOrder(model.id)"
                  ></customer-detail>
                </v-tab-item>
                <v-tab-item key="3" v-if="$can('discount', 'Order')">
                  <v-card flat>
                    <order-discount
                      :order="this.model"
                      @orderUpdate="getOrder(model.id)"
                    ></order-discount>
                  </v-card>
                </v-tab-item>
                <v-tab-item key="4">
                  <v-card flat>
                    <order-history :orderId="this.model.id"></order-history>
                  </v-card>
                </v-tab-item>
                <v-tab-item key="5">
                  <v-card flat>
                    <order-comment :orderId="this.model.id"></order-comment>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-card class="mb-2" :disabled="loading">
              <v-toolbar flat>
                <v-icon left color="accent">mdi-format-list-bulleted</v-icon>
                <v-toolbar-title>Order Rows</v-toolbar-title>
                <v-spacer></v-spacer>
                <add-custom-row
                    v-if="model && !readOnly"
                    :orderId="model.id"
                    @added="addProduct()"
                />
                <add-product
                  v-if="model && !readOnly"
                  :catalogId="model.shop.catalog_id"
                  :orderId="model.id"
                  @added="addProduct()"
                ></add-product>
              </v-toolbar>
              <order-rows-list
                :order="this.model"
                :items="this.model.rows"
                :currencySymbol="this.model.currency.currency"
                @removeProduct="getOrder(orderId)"
                @update="getOrder(orderId)"
                :readOnly="this.readOnly"
              ></order-rows-list>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-card v-if="this.model.discounts.length > 0" :disabled="loading">
              <v-toolbar flat>
                <v-icon left color="accent">mdi-format-list-bulleted</v-icon>
                <v-toolbar-title>Orders Discounts</v-toolbar-title>
              </v-toolbar>
              <order-discounts-list
                :items="this.model.discounts"
                :orderId="this.model.id"
                @orderUpdate="getOrder(orderId)"
              ></order-discounts-list>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="4">
        <v-row>
          <v-col>
            <v-card :disabled="loading">
              <v-toolbar flat >
                <v-toolbar-title>Details</v-toolbar-title>
              </v-toolbar>
              <v-list>
                <template v-if="this.model.prescriptionId">
                  <v-list-item>
                    <v-list-item-content
                      >Prescription Number:</v-list-item-content
                    >
                    <v-list-item-content class="align-end"
                      >#{{ this.model.prescriptionId }}</v-list-item-content
                    >
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item>
                    <v-list-item-content
                      >Prescription status:</v-list-item-content
                    >
                    <v-list-item-content class="align-end">
                      <b>{{ this.model.prescriptionStatusId }}</b>
                    </v-list-item-content>
                  </v-list-item>
                </template>
                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-content>Order Number:</v-list-item-content>
                  <v-list-item-content class="align-end"
                    >#{{ this.model.id }}</v-list-item-content
                  >
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-content>Order status:</v-list-item-content>
                  <v-list-item-content class="align-end">
                    <b>{{ this.model.statusId }}</b>
                  </v-list-item-content>
                </v-list-item>
                <template v-if="this.model.build">
                  <v-divider></v-divider>
                  <v-list-item>
                    <v-list-item-content>Build Status:</v-list-item-content>
                    <v-list-item-content>
                      <div class="d-flex align-center">
                        <b>{{ this.model.build.status_id }}</b>
                        <v-btn icon small class="ml-4" :href="'/build/build/' + model.build.id">
                          <v-icon small>mdi-open-in-new</v-icon>
                        </v-btn>
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </template>
                <template v-if="this.model.shippingTrackings && this.model.shippingTrackings.length">
                  <v-divider></v-divider>
                  <v-list-item v-for="tracking in model.shippingTrackings" :key="'tracking_' + tracking.id">
                    <v-list-item-content>Tracking ID:</v-list-item-content>
                    <v-list-item-content class="align-end">{{
                      tracking.tracking_id
                    }}</v-list-item-content>
                  </v-list-item>
                </template>
              </v-list>
              <v-card-actions v-if="this.model.statusId == 'new'" class="flex-wrap">
                <v-spacer />
                <v-btn class="accent" @click="validate()">
                  <v-icon left>mdi-check</v-icon>Validate
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <order-invoice-card :order="model" @update="addPayout" ref="invoices"/>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <order-summary v-model="model" />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row v-else align-center justify-center column fill-height>
      <v-progress-circular
        :size="70"
        :width="7"
        indeterminate
        color="error"
      ></v-progress-circular>
    </v-row>
    
    
    <ConfirmBox ref="confirm" />

  </v-container>
  <page-loading v-else />

</template>

<script>
import OrderInvoiceCard from "@components/invoices/OrderInvoiceCard.vue";
import OrderRowsList from "@components/orders/OrderRowsList.vue";
import OrderDiscountsList from "@components/orders/OrderDiscountsList.vue";
import OrderDetail from "@components/orders/OrderDetail.vue";
import OrderHistory from "@components/orders/OrderHistory.vue";
import OrderComment from "@components/orders/OrderComment.vue";
import CustomerDetail from "@components/orders/CustomerDetail.vue";
import OrderDiscount from "@components/orders/OrderDiscount.vue";
import AddProduct from "@components/orders/AddProduct";
import OrderSummary from "@components/orders/OrderSummary.vue";
import ConfirmBox from '@components/ui/ConfirmBox.vue';
import AddCustomRow from '@components/orders/AddCustomRow.vue'

//import ORDER_STATUS from "@/utils/order.status.js";
import INVOICE_STATUS from "@/utils/invoice.status.js";

import { mapGetters } from 'vuex';
import PageLoading from '../../components/PageLoading.vue';

export default {
  components: {
    AddProduct,
    OrderRowsList,
    OrderDetail,
    CustomerDetail,
    OrderDiscount,
    OrderDiscountsList,
    OrderHistory,
    OrderComment,
    OrderSummary,
    ConfirmBox,
    OrderInvoiceCard,
    PageLoading,
    AddCustomRow
  },
  data: () => ({
    orderId: null,
    model: null,
    tabs: null,
    payoutOpen: false,
    message: null,
  }),
  mounted: function() {
    if (this.$route.params.id) {
      this.orderId = this.$route.params.id;
      this.getOrder(this.orderId);
    } else {
      this.$route.push("/orders");
    }
  },
  watch:{
    errors(errors){
      this.message=[]
      this.message.push(errors);
    }
  },
  computed: {
    ...mapGetters("auth", ["currentUser"]),
    ...mapGetters("orders",["errors", "loading"]),
    readOnly() {
      return ['close', 'cancel'].includes(this.model.statusId)
    },
    canPayout() {
      if (
        this.model.invoice &&
        INVOICE_STATUS.isOpen(this.model.invoice.statusId)
      ) {
        return true;
      } else {
        return false;
      }
    },
    canMarkAsSent() {
      if (this.model.invoice && this.model.invoice.statusId == "new") {
        return true;
      } else {
        return false;
      }
    },
    canSentToStock() {
      if (
        !this.model.build &&
        this.model.invoice &&
        this.model.statusId == "open"
      ) {
        return true;
      } else {
        return false;
      }
    },
    canBeValidate() {
      if(this.model && (!this.model.billingAddress || !this.model.shippingAddress)){
        return false
      }
      if(this.model && this.model.billingAddress && !this.model.billingAddress.areComplete) {
        return false
      }
      return true
    }
  },
  methods: {
    getOrder(id) {
      this.$store
        .dispatch("orders/get", {
          id: id,
        })
        .then((data) => {
          this.model = data
          if(this.$refs.invoices){
            this.$refs.invoices.load()
          }
        });
    },
    updateModel(newModel) {
      this.model = newModel;
    },
    async validate() {
      if(!this.canBeValidate) {
        await this.$refs.confirm.open("Cannot be validate", "Billing adresse or shipping adresse are not completed")
      }else if(await this.$refs.confirm.open("Confirm", "When you confirm this order, the client received a confirmation mail and this order are transmitted to the stock")){
        this.$store
          .dispatch("orders/validate", {
            orderId: this.model.id,
          })
          .then((result) => {
            if (result.success) {
              this.getOrder(result.model.id)
            } else {
              this.message = [];
              for (const field in result.message) {
                if ({}.propertyIsEnumerable.call(result.message, field)) {
                  const msg = result.message[field];
                  this.message.push(msg[0]);
                }
              }
            }
          });
      }
    },
    markAsSent() {
      this.$store
        .dispatch("orders/markAsSent", {
          orderId: this.model.id,
        })
        .then((data) => (this.model = data));
    },
    sent() {
      this.$store
        .dispatch("orders/sent", {
          orderId: this.model.id,
        })
        .then((data) => (this.model = data));
    },
    reopen() {
      this.$store
        .dispatch("orders/reopen", {
          orderId: this.model.id,
        })
        .then((data) => (this.model = data.model));
    },

    cancel() {
      confirm(
        "Are you sure you want to cancel this order and credit user account (if necessary) ?"
      ) &&
        this.$store
          .dispatch("orders/cancel", {
            orderId: this.model.id,
          })
          .then((data) => (this.model = data.model));
    },
    sendToStock() {
      this.$store
        .dispatch("orders/sendToStock", {
          orderId: this.model.id,
        })
        .then(({model}) => (this.model = model));
    },
    cancelPayout() {
      this.payoutOpen = false;
    },
    addPayout() {
      this.getOrder(this.orderId);
    },
    addProduct() {
      this.getOrder(this.orderId);
    },
  },
};
</script>
